export default "<h1>Type10Mixed list</h1>\n<spec-app-type10-mixed-table [clickHandler]=\"createClickHandler()\"></spec-app-type10-mixed-table>";